/* Only lines carrying our private marker are owned by this optional offer. */
(() => {
  const marker = 'g1m-seat-v1';
  const triggerIds = [15194437058726,15207869513894,15836836200614,15286165176486,15286166388902,15286164291750];
  let locked = false;
  const base = () => window.Shopify.routes.root;
  const owns = item => item.properties?._yesoul_optional_offer === marker;
  async function readCart() {
    const r = await fetch(base() + 'cart.js', {cache:'no-store'});
    if (!r.ok) throw new Error("Impossible d’actualiser votre panier. Veuillez réessayer.");
    return r.json();
  }
  if (customElements.get('yesoul-cart-offer')) return;
  customElements.define('yesoul-cart-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('[data-offer-toggle]');
      this.status = this.querySelector('[data-offer-status]');
      this.select = this.querySelector('select');
      this.select.addEventListener('change', () => {
        this.querySelector('[data-offer-price]').textContent = this.select.selectedOptions[0].dataset.price;
      });
      this.toggle.addEventListener('change', () => this.change());
      this.abort = new AbortController();
      document.addEventListener('cart:change', e => {
        if (!locked && e.detail?.cart?.items) this.sync(e.detail.cart);
      }, {signal:this.abort.signal});
      readCart().then(c => { if (!locked && this.isConnected) this.sync(c); }).catch(() => {});
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
    sync(cart) {
      const items = cart.items.filter(i => String(i.product_id) === this.dataset.productId);
      const owned = items.filter(owns);
      const trigger = cart.items.some(i => triggerIds.includes(i.product_id));
      this.hidden = !trigger || (!owned.length && items.length > 0);
      this.toggle.checked = owned.length > 0;
      this.select.disabled = owned.length > 0;
      if (owned.length) this.select.value = String(owned[0].variant_id);
    }
    async change() {
      const wanted = this.toggle.checked;
      if (locked) { this.toggle.checked = !wanted; return; }
      locked = true;
      const widgets = [...document.querySelectorAll('yesoul-cart-offer')];
      widgets.forEach(w => { w.toggle.disabled = true; w.setAttribute('aria-busy','true'); });
      this.status.hidden = true;
      let mutated = false;
      let current;
      try {
        current = await readCart();
        const lines = current.items.filter(i => String(i.product_id) === this.dataset.productId);
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        let result;
        if (wanted && !lines.length) {
          if (!current.items.some(i => triggerIds.includes(i.product_id))) throw new Error("Le vélo ou le pack éligible n’est plus dans votre panier.");
          const r = await fetch(base()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:Number(this.select.value),quantity:1,properties:{_yesoul_optional_offer:marker}}],sections,sections_url:location.pathname})});
          result = await r.json();
          if (!r.ok) throw new Error(typeof result.description === 'string' ? result.description : "Impossible d’ajouter cet article.");
          mutated = true;
        } else if (!wanted) {
          // Fresh cart keys, never product/variant IDs or positional line numbers.
          for (const line of lines.filter(owns)) {
            const r = await fetch(base()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:line.key,quantity:0,sections,sections_url:location.pathname})});
            result = await r.json();
            if (!r.ok) throw new Error("Impossible de retirer cet accessoire. Veuillez vérifier votre panier.");
            mutated = true;
          }
        }
        current = await readCart();
        current.sections = result?.sections || {};
        if (mutated) {
          if (wanted) this.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items||[result],cart:current,blockCartDrawerOpening:true}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:wanted?'variant:add':'line-item:change',cart:current}}));
        }
        this.status.textContent = wanted ? "Sélection mise à jour." : "Housse de selle en option retirée.";
        // Impact's cart page uses a full navigation for line updates. Match that behavior.
        if (mutated && window.themeVariables.settings.pageType === 'cart') location.reload();
      } catch (e) {
        this.status.textContent = mutated ? "Panier mis à jour. Ouvrez-le pour vérifier le nouveau total." : e.message;
        try { current = await readCart(); } catch (_) { this.toggle.checked = !wanted; }
      } finally {
        locked = false;
        widgets.forEach(w => {
          if (current) w.sync(current);
          w.toggle.disabled = false;
          w.removeAttribute('aria-busy');
        });
        this.status.hidden = false;
      }
    }
  });
})();
